import type { UploadFile } from 'antd/lib/upload/interface';
import type { SetState } from 'zustand';
import { FormMeterFileValue } from 'services/api/inventoryMeters';
import { MeterFileValue } from '@enmon/commons/lib/enmon/files/values';
import type { InstallMeterStore } from '../../useStore';

const photoTypes = Object.values(MeterFileValue);

const photoReduce = photoTypes.reduce((acc, currentItem) => ({ ...acc, [currentItem]: undefined }), {}) as Record<
  FormMeterFileValue,
  undefined
>;

const INITIAL_STATE: PhotoStepForm = photoReduce;

export type PhotoStepForm = Record<FormMeterFileValue, UploadFile[] | undefined>;

export type PhotoStepSlice = PhotoStepForm & {
  resetPhotoStepSlice: () => void;
  setPhotoStepValues: (values: PhotoStepForm) => void;
};

export const createPhotoStepSlice = (set: SetState<InstallMeterStore>): PhotoStepSlice => ({
  ...INITIAL_STATE,
  setPhotoStepValues: (values: PhotoStepForm) => set(values),
  resetPhotoStepSlice: () => set(INITIAL_STATE),
});
